export const SYNC_NOTIFICATIONS_CHANNEL = '@@notificationsChannel/sync'
export const SYNC_SENT_NOTIFICATIONS_CHANNEL = '@@notificationsChannel/syncSent'
export const SYNC_CANCEL_NOTIFICATIONS_CHANNEL = '@@notificationsChannel/syncCancelled'

export const UPDATE_NOTIFICATIONS_CHANNEL = '@@notificationsChannel/update'
export const CLEAR_NOTIFICATIONS_CHANNEL = '@@notificationsChannel/clearNotification'

export const OPEN_NOTIFICATION_CHANNEL = '@@notificationsChannel/open'
export const CLOSE_NOTIFICATION_CHANNEL = '@@notificationsChannel/close'
